export default () => {
  const blogList = document.querySelectorAll('[component="blog-list"]');

  blogList.forEach((list) => {
    const tagChild = list.querySelectorAll('[child="tag"]');

    tagChild.forEach((tag) => {
      const { backgroundColor } = tag.dataset;

      if (backgroundColor) {
        tag.style.backgroundColor = backgroundColor;
      }
    });
  });
};
